import { memo } from 'react';
import { Box, Button, Typography } from '@mui/material';

import { redirectButton } from '../../const/componentSize';
import { redirectButtonLabel } from '../../const/commonConst';

import theme from '../../../theme';

type PropsType = {
	handleOpenOffsegMenu: (event: React.MouseEvent<HTMLElement>) => void;
	handleOpenG500LiteMenu: (event: React.MouseEvent<HTMLElement>) => void;
};

/**
 * リダイレクトボタン
 */
const RedirectButton = (props: PropsType) => {
	const { handleOpenOffsegMenu, handleOpenG500LiteMenu } = props;
	return (
		<Box sx={{ flexGrow: 1, minWidth: redirectButton.boxMinWidth }}>
			<Button id="offsegRedirectButton" variant="outlined" onClick={handleOpenOffsegMenu} sx={{ width: redirectButton.buttonWidth }}>
				<Typography sx={{ fontSize: 15, color: theme.palette.common.black }}>{redirectButtonLabel.offseg}</Typography>
			</Button>
			<Button id="g500LiteRedirectButton" variant="outlined" onClick={handleOpenG500LiteMenu} sx={{ width: redirectButton.buttonWidth, marginLeft: redirectButton.marginLeft }}>
				<Typography sx={{ fontSize: 15, color: theme.palette.common.black }}>{redirectButtonLabel.g500Lite}</Typography>
			</Button>
		</Box>
	);
};

export default memo(RedirectButton);
